import decode from 'jwt-decode';
import axios from 'axios';
import qs from 'qs';

export default class AuthService {
  authenticateUser(email, password) {
    const formData = {
      username: email,
      password: password
    };
    return axios(`${process.env.REACT_APP_API_URL}/legacy/login`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      mode: 'cors',
      data: qs.stringify(formData)
    })
      .then(response => {
        return response.data;
      })
      .then(userData => {
        var token = userData.Token;
        var user = JSON.stringify(userData.user);
        if (token) {
          this.setToken(token);
          this.setUser(user);
        }
        return userData;
      })
      .catch(e => {
        console.log('error', e);
      });
  }

  userAuthenticated() {
    if (this.isFsid()) {
      const user = this.getUser();
      if (user && user.sessionId) {
        return true;
      }
    } else {
      const Token = this.getToken();
      if (this.tokenSeemsValid(Token)) {
        return true;
      }
    }
    return false;
  }

  deauthenticateUser(Token, User) {
    localStorage.removeItem('user');
    localStorage.removeItem('userToken');
    if (this.isFsid()) {
      localStorage.removeItem('isFsid');
      window.open(process.env.REACT_APP_FSID_LOGOUT_URL, '_self');
    } else {
      setTimeout(Token, 100);
      window.location = '/';
    }
  }

  tokenSeemsValid(Token) {
    if (Token) {
      try {
        const decoded = decode(Token);
        if (decoded && decoded.exp && decoded.exp > Date.now() / 1000) {
          return true;
        }
      } catch (err) {
        return false;
      }
    }
    return false;
  }

  setToken(Token) {
    localStorage.setItem('userToken', Token);
  }

  getToken() {
    return this.isFsid()
      ? localStorage.getItem('user.sessionId')
      : localStorage.getItem('userToken');
  }

  setUser(User) {
    localStorage.setItem('user', User);
  }

  getUser() {
    if (this.isFsid()) {
      return JSON.parse(localStorage.getItem('user'));
    } else {
      const Token = this.getToken();
      if (Token) {
        decode(this.getToken());
        return JSON.parse(localStorage.getItem('user'));
      }
    }
    return false;
  }

  setIsFsid(isFsid) {
    localStorage.setItem('isFsid', isFsid);
  }

  isFsid() {
    const isFsid = localStorage.getItem('isFsid');
    return isFsid === 'true' ? true : false;
  }

  checkSso(email) {
    const formData = {
      username: email
    };
    return axios(`${process.env.REACT_APP_API_URL}/legacy/login`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'POST',
      mode: 'cors',
      data: qs.stringify(formData)
    })
      .then(response => {
        return response.data;
      })
      .then(groupData => {
        var isFsid = groupData.Token || false;
        this.setIsFsid(isFsid);
        return groupData;
      })
      .catch(e => {
        console.log('error', e);
      });
  }

  exchangeToken(code) {
    var url = `${process.env.REACT_APP_API_URL}/session/getToken`;
    var data = `code=${code}&redirect=${process.env.REACT_APP_INPERSON_URL}`;
    var config = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      withCredentials: true
    };

    return axios
      .post(url, data, config)
      .then(response => {
        return response.data;
      })
      .then(userData => {
        var user = JSON.stringify(userData.user);
        if (userData.user.sessionId) {
          this.setUser(user);
          this.setIsFsid(true);
        }
        return userData;
      })
      .catch(e => {
        console.log('error', e);
      });
  }

  startSessionPoller(sessionId) {
    window.FormstackId.SessionPoller.setOptions({
      server: process.env.REACT_APP_FSID_URL,
      sid: sessionId,
      frequency: 10,
      onSessionExpired: this.deauthenticateUser
    });

    window.FormstackId.SessionPoller.start();
  }

  refreshUserCredentials() {
    const user = this.getUser();
    return new Promise((resolve, reject) => {
      if (user) {
        this.startSessionPoller(user.sessionId);

        window.FormstackId.SessionPoller.checkInGoodStanding().then(function(
          good
        ) {
          if (good) {
            resolve(user);
          } else {
            reject(false);
          }
        });
      } else {
        reject(false);
      }
    }).catch(e => {
      console.log(e);
    });
  }
}



// WEBPACK FOOTER //
// ./src/AuthService.js